import { EventEmitter, Injectable } from '@angular/core';
import { first, map, Observable, tap} from 'rxjs';
import { AuthorizedApiService, CommonService, LaasyCookieService } from '@laasy/common-layout';
import { ApiResponse } from '../models/apiResponse';
import { UserProfileAttributeUpdateRequest } from '../models/profile/profile';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  profileUpdated = new EventEmitter<any>();
  constructor(private cookieService:LaasyCookieService,
    private commonService:CommonService,
    private readonly apiService: AuthorizedApiService) {}

  GetUserProfile(): Observable<ApiResponse> {
    return this.apiService.getAndCache<ApiResponse>(
      'user/api/profile/details'
    ).pipe(first(),map((res: any) => {
      const phoneNumber = res.data.attributes.find((y: any) => y.title === 'Phone number')
      const isPhoneNoValid = phoneNumber?.value !== '0000000000'
      if(!isPhoneNoValid) phoneNumber.value = ''
      return res
    }));
  }

  UpdateUserProfile(request: UserProfileAttributeUpdateRequest): Observable<ApiResponse> {
    this.cookieService.removeUserAPICache()
    return this.apiService.put<ApiResponse>(
      'user/api/profile/updateuserprofileattribute',
      request
    ).pipe(tap(_=>this.commonService.getUserContext()));
  }

  deleteUserAccount(user: any): Observable<ApiResponse> {
    return this.apiService.post<ApiResponse>('user/api/usermanagement/cancelMembership?vendor=Laasy', user)
  }

}
